export default __webpack_public_path__ + "static/media/black01.299d4d66.jpg";